<template id="userTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <div class="main-div" :class="formState.invalidShake?'--invalid':''">
      <small
        class="--centered-block"
      >Click a user to add him/her to the recipients list. Only Users with mobile phones are shown.</small>

      <div class="form-group col-12 col-sm-12">
        <label class="pl-0 col-12 col-sm-12">All Users</label>
        <div class="mb-4 p-0 col-12 col-sm-12">
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">Email</label>
            <input
              class="form-control col-12 col-sm-12"
              type="text"
              maxlength="200"
              v-model="searchCriteria.email"
              placeholder="Search By Email"
              v-on:input="searchPage=1;fetchAllUsers()"
            />
          </div>
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">Mobile</label>
            <input
              class="form-control col-12 col-sm-12"
              type="text"
              maxlength="200"
              v-model="searchCriteria.mobile"
              placeholder="Search By Mobile"
              v-on:input="searchPage=1;fetchAllUsers()"
            />
          </div>
          <div class="p-0 col-12 col-sm-3">
            <label class="pl-0 col-12 col-sm-12">City</label>
            <b-form-select
              :disabled="formState.loading"
              class="modified-dropdown form-control col-12 col-sm-12"
              :options="dropDownPlaces"
              v-model="searchCriteria.placeId"
              v-on:input="searchPage=1;fetchAllUsers()"
            ></b-form-select>
          </div>
        </div>
        <div class="user-row">
          <p class="user-heading">Name</p>
          <p class="user-heading">Email</p>
          <p class="user-heading">Mobile</p>
          <p class="user-heading">Address</p>
          <p class="user-heading">Discount</p>
          <p class="user-heading">City</p>
          <p class="user-heading">Existing Customer</p>
        </div>
        <div
          v-for="(user,index) in fetchedUsers"
          v-on:click="addNumber(user.name,user.mobile)"
          class="user-row"
          :key="index"
          :class="user.mobile?'':'hidden'"
        >
          <p class="user-col">{{user.name}}</p>
          <p class="user-col">{{user.email}}</p>
          <p class="user-col">{{user.mobile?user.mobile:'Unkown'}}</p>
          <p class="user-col">{{user.address?user.address:'Unknown'}}</p>
          <p class="user-col">{{user.discount?user.discount:'None'}}</p>
          <p class="user-col">{{searchPlace(user.area_id)?searchPlace(user.area_id).name:'Unknown'}}</p>
          <p class="user-col">{{user.isPrev==true?'Yes':'No'}}</p>
        </div>
        <div
          style="justify-content: center;"
          v-if="fetchedUsers.length<20"
          class="alert alert-info w-100"
        >No more users</div>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(false)"
          v-if="(!isSearching() && (searchCriteria.page>1)) || (isSearching() && (searchPage>1))"
          :disabled="formState.loading"
        >Previous Page</button>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="fetchedUsers.forEach((usr)=>{if(usr.mobile)addNumber(usr.name,usr.mobile,false,true)});"
          v-if="fetchedUsers.length>0"
          :disabled="formState.loading"
        >Add this page to recipients list</button>
        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3"
          v-on:click="advancePageAndFetch(true)"
          v-if="fetchedUsers.length>=20"
          :disabled="formState.loading"
        >Next Page</button>
      </div>

      <hr />

      <div class="form-group col-12 col-sm-12">
        <div class="col-12 col-sm-12">
          <small class="--centered-block">Add numbers manually</small>
        </div>
        <div v-if="errors.length" class="col-12 col-sm-12">
          <ul>
            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>

        <div class="p-0 col-12 col-sm-3 m-1">
          <label class="pl-0 col-12 col-sm-12">Name</label>
          <input
            class="form-control col-12 col-sm-12"
            type="text"
            maxlength="50"
            v-model="newNumber.name"
            placeholder="ex. Ahmed"
            v-on:input="checkForm()"
          />
        </div>

        <div class="p-0 col-12 col-sm-3 m-1">
          <label class="pl-0 col-12 col-sm-12">Mobile Number</label>
          <input
            class="form-control col-12 col-sm-12"
            type="number"
            maxlength="50"
            v-model="newNumber.mobile"
            placeholder="ex. 00201020304050"
            v-on:input="checkForm()"
          />
        </div>

        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3 m-1"
          style="margin-bottom:0.25rem!important"
          v-on:click="checkForm();errors.length?1:addNumber(newNumber.name,newNumber.mobile,true)"
          :disabled="formState.loading"
        >Add Number to recipients list</button>
      </div>

      <hr />

      <div class="form-group col-12 col-sm-12">
        <small class="--centered-block">Selected Numbers</small>
        <div class="user-row">
          <p class="user-heading-1-3">Name</p>
          <p class="user-heading-1-3">Mobile</p>
          <p class="user-heading-1-3" style="color:transparent">stub</p>
        </div>
        <div v-for="(recipient,index) in selectedNumbers" class="user-row" :key="index">
          <!-- recipient -->
          <p class="user-col-1-3">{{recipient.name}}</p>
          <p class="user-col-1-3">{{recipient.mobile}}</p>
          <p class="user-col-1-3 btn-danger" v-on:click="removeNumber(index)">Remove</p>
        </div>
      </div>

      <hr />

      <div class="form-group col-12 col-sm-12">
        <div
          v-if="(sms.length<3 || sms.length>160) && formState.attempted"
          class="col-12 col-sm-12"
        >
          <ul>
            <li>SMS must be between 3 and 160 charchters</li>
          </ul>
        </div>
        <div class="col-12 col-sm-12">
          <small class="--centered-block">Enter the SMS you want to send</small>
        </div>
        <div style="min-width:100%" class="p-0 col-12 col-sm-3 m-1">
          <label class="pl-0 col-12 col-sm-12">SMS</label>
          <input
            class="form-control col-12 col-sm-12"
            type="text"
            maxlength="160"
            v-model="sms"
            placeholder="ex. Welcome to our new website"
          />
        </div>

        <button
          type="button"
          class="mb-2 btn btn-info col-12 col-sm-3 m-1"
          style="margin-bottom:0.25rem!important"
          v-on:click="formState.attempted=true;sendSMS()"
          :disabled="formState.loading"
        >SendSMS</button>
      </div>
    </div>
  </div>
</template>



<!-- user Template -->




<style lang='scss' scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.hidden {
  display: none !important;
}
.selected-user {
  background-color: #5fbff9 !important;
}
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.main-div {
  padding: 50px;
  width: 80%;
  ::-webkit-scrollbar {
    width: 0px;
    height: 5px;
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: darkgray;
  }
  div {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    justify-content: space-between;
  }
  .--height-max-content {
    height: max-content;
  }
  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
  .separator {
    display: block;
    width: 100%;
    clear: both;
  }
  .--black-background {
    background-color: black;
  }

  .--centered-block {
    margin: 0 auto;
  }
  .default-tag {
    background-color: #17a2b8;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
  }

  .close-div-tag {
    background-color: #db0a5b;
    border-style: solid;
    border-color: transparent;
    border-radius: 5px;
    font-size: 0.8em;
    padding: 0 5px;
    color: white;
    cursor: pointer;
  }

  .user-row {
    width: 100%;
    padding: 5px;
    // overflow-x: scroll;
    height: auto;
    display: flex;
    border-radius: 5px;
    border-style: solid;
    border-color: transparent;
    background-color: #eeeeee;
    margin-bottom: 5px;
    cursor: pointer;
    &__measurement {
      cursor: default;
      padding-bottom: 10px !important;
    }
    &__order {
      cursor: default;
      padding-bottom: 10px !important;
      width: 100%;
    }
  }

  .user-heading {
    text-align: center;
    width: 14%;
    font-weight: bold;
    margin-bottom: 0;
  }
  .user-col {
    text-align: center;
    width: 14%;
    overflow-x: scroll;
    margin-bottom: 0;
  }
  .user-heading-1-3 {
    text-align: center;
    width: 33%;
    font-weight: bold;
    margin-bottom: 0;
  }
  .user-col-1-3 {
    text-align: center;
    width: 33%;
    overflow-x: scroll;
    margin-bottom: 0;
    white-space: nowrap;
  }
}
//  0.82s
.--invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
import { setTimeout } from "timers";
/* eslint-enable no-unused-vars*/
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "usersCRUD",
  data() {
    return {
      sms: "",
      selectedNumbers: [],
      newNumber: { name: "", mobile: "" },
      searchPage: 1,
      searchCriteria: { page: 1, email: null, mobile: null, placeId: null }, // We search All users Depending on this.
      fetchedUsers: [], // fetched Users (page dependant).
      places: [], // Data about all places fetched from the API
      dropDownPlaces: [{ value: null, text: "Please Select a city" }], // Only cities are shown
      errors: [], // Form's errors
      formState: {
        loading: false,
        attempted: false,
        invalidShake: false
      } // Object Determining the Form's state
    };
  },
  mounted() {
    this.fetchAllPlaces();
    this.fetchAllUsers();
  },
  methods: {
    isSearching() {
      return !(
        (this.searchCriteria.email == "" ||
          this.searchCriteria.email == null) &&
        (this.searchCriteria.mobile == "" ||
          this.searchCriteria.mobile == null) &&
        this.searchCriteria.placeId == null
      );
    },
    advancePageAndFetch: function(increment) {
      if (increment) {
        if (this.isSearching()) {
          this.searchPage++;
        } else {
          this.searchCriteria.page++;
        }
      } else {
        if (this.isSearching()) {
          this.searchPage--;
        } else {
          this.searchCriteria.page--;
        }
      }
      this.fetchAllUsers();
    },
    addNumber: function(name, mobile, resetNewNumber, ignoreAlert) {
      let numberAlreadyExists = this.selectedNumbers.findIndex(elem => {
        return elem.mobile == mobile;
      });
      if (numberAlreadyExists < 0) {
        this.selectedNumbers.push({
          name: name,
          mobile: mobile
        });
        if (resetNewNumber) this.newNumber = { name: "", mobile: "" };
      } else {
        if (!ignoreAlert) alert("Number already added to recipients list");
      }
    },
    sendSMS() {
      if (this.sms.length >= 3 && this.sms.length <= 160) {
        if (this.selectedNumbers.length > 0) {
          if (
            confirm(
              `Please confirm you want to send ${this.sms} to the selected users`
            )
          ) {
            this.formState.loading = true;
            let numbersArr = [];
            this.selectedNumbers.forEach(num => {
              numbersArr.push(num.mobile);
            });
            return axios
              .post(
                `${herokuUrl}/dashboard/broadcastSMS`,
                {
                  numbersArr: numbersArr,
                  message: this.sms
                },
                {
                  headers: {
                    Authorization: getCookie("user")
                  }
                }
              )
              .then(() => {
                alert("SMS was sent successfully");
                window.location.reload();
              })
              .catch(err => {
                if(err.response.status == 401) {
                  logOut();
                } else {
                  this.formState.loading = false;
                  alert("SMS sending Failed " + err.response.data.message);
                }
              });
          }
        } else {
          alert("Please select numbers to send SMS to.");
        }
      }
    },
    removeNumber: function(index) {
      this.selectedNumbers.splice(index, 1);
    },
    // Partially resets the form
    partiallyResetForm: function() {
      // this.cancelNewUser();
      this.fetchAllUsers();
      this.selectedUserData = null;
      this.selectedUserId = null;
      this.errors = [];
      this.formState = {
        loading: false,
        attempted: false,
        invalidShake: false
      };
    },
    checkForm: function() {
      this.errors = [];
      if (!this.newNumber.name)
        this.errors.push("Recipient's name is required");
      if (!this.newNumber.mobile)
        this.errors.push("Recipient's number is required");
      if (this.newNumber.name.length < 3 || this.newNumber.name.length > 100)
        this.errors.push("Name should be between 3 and 100 characters");
      if (this.newNumber.mobile.length < 5 || this.newNumber.mobile.length > 25)
        this.errors.push("Number should be between 5 and 25 digits");
    },
    searchPlace(placeId) {
      for (let i = 0; i < this.places.length; i++) {
        if (this.places[i].id == placeId) return this.places[i];
      }
      return null;
    },
    fetchAllPlaces() {
      this.formState.loading = true;
      return axios
        .post(`${herokuUrl}/dashboard/getAllplaces`, null, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.places = res.data.places;
          this.dropDownPlaces = [
            { value: null, text: "Please Select a city" }
          ];
          this.places.forEach(place => {
            if (place.country_id != null || place.country_id != null){
              this.dropDownPlaces.push({ value: place.id, text: place.name });
            }
          });
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "Locations fetching failed, " +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    fetchAllUsers() {
      this.formState.loading = true;
      return axios
        .post(
          `${herokuUrl}/dashboard/getAllusers`,
          {
            searchCriteria: {
              ...this.searchCriteria,
              page: this.isSearching()
                ? this.searchPage
                : this.searchCriteria.page
            }
          },
          {
            headers: {
              Authorization: getCookie("user")
            }
          }
        )
        .then(res => {
          this.fetchedUsers = res.data.allUsers;
          this.fetchedUsers.forEach(usr => {
            usr.selected = false;
          });
          this.formState.loading = false;
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert(
              "Users fetching failed, " +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>